import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {deleteNotification} from 'src/openapi/admin/apis/InternalNotificationApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    notificationId: string,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRemoveNotification = ({notificationId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        deleteNotification({notificationId}),
    ), [notificationId, apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
